<template lang="pug">
div.collection(:class="{ 'collection-swiper-container': sliderMode }" ref="collection-container")
  h2.padding-left-sm-0.padding-right-sm-0.margin-bottom-sm-1.margin-bottom-xs-1(v-if="displayTitle") {{ title }}
  div.relative(:class="{ 'swiper-container': sliderMode }")
    template(v-if="sliderMode")
      div.swiper-wrapper
        div.swiper-slide(v-for="(item, idx) in items", :class="{ 'sold-out': item.availability == 'O' }", v-if="itemsFiltered.indexOf(item) !== -1")
          div.case.mb1.artwork
            div.relative.text-center
              a(:href="item.art_work_url")
                img.slide-image.block(:src="item.art_work_preview")
              footer.relative
                div.main-info.flex-box(layout="row", layout-align="start")
                  div(flex, :class="'text-center'", :data-sub-title="custom.items[idx]? (custom.items[idx].subTitle || false) : false")
                    a.name.text-grey1.ellipsis(:href="item.art_work_url") {{ item.seo_prefix? `${item.seo_prefix} - ` : ''}}{{ item.artwork_desc }}
                    span.ellipsis.text-grey3.price {{ (displayPrice && item.price)? item.price : ' '}}
    template(v-else)
      ul.row.reset-list.relative(v-if="itemsFiltered.length", ref="ul")
        li.case.mb1.artwork(v-for="(item, idx) in items", :class="['column3', 'xs-column6', 'xs-thin-column'].concat(item.availability == 'O' ? ['sold-out'] : [])", v-if="itemsFiltered.indexOf(item) !== -1")
          div.relative.text-center
            a(:href="item.art_work_url")
              img.case-img.f-width.flex-img.block(:src="item.art_work_preview")
            footer.relative
              div.main-info.flex-box(layout="row", layout-align="start")
                div(flex, :class="'text-left'", :data-sub-title="custom.items[idx]? (custom.items[idx].subTitle || false) : false")
                  a.name.text-grey1.ellipsis(:href="item.art_work_url") {{ item.seo_prefix? `${item.seo_prefix} - ` : ''}}{{ item.artwork_desc }}
                  span.ellipsis.text-grey3.price {{ (displayPrice && item.price)? item.price : ' '}}
  div.swiper-button-prev(v-if="sliderMode")
  div.swiper-button-next(v-if="sliderMode")
</template>

<script>

const _ = require('lodash')

export default {

  components : {
  },

  props : ['mode', 'custom', 'boundCollection', 'sliderMode', 'initSwiper'],

  name: 'collection',

  data() {

    return {

      items : [],
      title : null,

      // Generic properties
      eventHub : window.vueEventHub || new Vue(),
      currentSegmentIds : (window.Server && Server.sgmtIds && Server.sgmtIds.split(',')) || []

    }
  },

  computed : {

    isCustomMode() { return this.mode === 'custom' },
    isBoundToCollection() { return this.mode === 'bindToCollection' },

    displayTitle() {
      if (this.isCustomMode) return this.title && !!this.title.trim()
      else return this.title && !!this.title.trim() && this.boundCollection.displayHeader
    },

    displayPrice() {
      if (this.isCustomMode) return false
      return this.boundCollection.displayPrice
    },

    itemsFiltered() {

      if (!this.isCustomMode) return this.items

      return this.items.filter((item, i) => {

        let segmentId = this.custom.items[i].segmentId
        if (!segmentId || segmentId.trim() === '') {
          return true
        }

        let slideSegmentIds = segmentId.split(',').map(s => s.trim())
        let shouldDisplay = false
        slideSegmentIds.forEach(id => {
          if (!shouldDisplay) {
            shouldDisplay = this.currentSegmentIds.includes(id)
          }
        })

        return shouldDisplay

      })
    }

  },

  watch : {

  },

  async created() {

    [this.title, this.items] = await this.fetchData()
    if (this.sliderMode) {
      const selfEl = this.$refs['collection-container']
      const vm = this
      setTimeout(function () { vm.initSwiper(selfEl) }, 100)
    }

  },

  methods : {

    async fetchData() {

      if (this.isBoundToCollection) {
        let { displayCount, collectionId } = this.boundCollection
        const resp = await fetch(`/controllers/Collection.php?fn=getCollectionArtworks&limit=${displayCount}&id=${collectionId}&withCollectionName`).then(res => res.json())
        if (resp.error) return [null, []]
        else {
          const data = resp.data
          return [
              data.meta.collection_name,
              data.data.filter(artwork => !!artwork.art_work_id)
            ]
        }
      }

      if (this.isCustomMode) {
        return Promise.resolve([
          this.custom.title,
          this.custom.items.map(alignSchema)
        ])
      }

      function alignSchema(item) {
        return {
          art_work_id : null,
          art_work_url : item.url,
          art_work_locale : null,
          art_work_preview : item.image,
          artwork_desc : item.title,
          price : item.price,
          original_price : null,
          type : 'artwork'
        }
      }

    },

    cdnImage(src) {
      return `${CDN_URL_PREFIX}${src}`
    },

    scrollLeft() {
      let el = this.$refs.ul
      let { width } = el.getBoundingClientRect()
      let x = el.scrollLeft
      el.scrollTo({ left : x - width, behavior : 'smooth' })
    },

    scrollRight() {
      let el = this.$refs.ul
      let { width } = el.getBoundingClientRect()
      let x = el.scrollLeft
      el.scrollTo({ left : x + width, behavior : 'smooth' })
    }

  }
}
</script>

<style lang="scss" scoped>
ul.slider-mode {
  white-space: nowrap;
  overflow: auto;
  @media (min-width: 768px) {
    overflow: hidden;
  }
  -webkit-overflow-scrolling: touch;
  li {
    display: inline-block;
    float: none;
    width: 25%;
    @media (max-width: 767px) {
      width: 42%;
    }
  }
}

ul {
  li.artwork.sold-out {
    position: relative;
    &>div {
      opacity: 0.5;
    }
    &::after {
      content : 'SOLD OUT';
      position : absolute;
      color: black;
      left : 50%;
      top: calc(50% - 25px);
      transform : translateX(-50%) translateY(-50%);
      text-shadow: 0 0 1px white;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
a.scroll {
  width: 30px;
  height: 100%;
  top: 0;
  z-index: 1;
  img {
    top: 40%;
    transform: translateY(-50%);
    position: absolute;
  }
  &.left {
    left: 0;
  }
  &.right {
    right: 0;
  }
}
</style>


// WEBPACK FOOTER //
// CMSCollection.vue?6b2045a3